import AudioEffect from '../effects/audio/AudioEffect';
import * as Tone from 'tone';
import AutomationManager from './AutomationManager';
import Clip from './Clip';
import ClipSlot from './ClipSlot';
import LiveState from './LiveState';
class Track {
    constructor() {
        this.clipSlots = [];
        this._firedState = new Tone.Timeline();
        this._playingState = new Tone.Timeline();
        this.outputNode = new Tone.Gain(0, "decibels");
        this.meter = new Tone.Analyser("waveform", 512);
        this.automationManager = new AutomationManager();
        this.output().connect(LiveState.Master.input);
        this.automationManager.makeAutomatable('Mixer', 'Volume', this.outputNode.gain);
        this.output().connect(this.meter);
        LiveState.tracks.push(this);
    }
    get volume() {
        return this.outputNode.gain.value;
    }
    set volume(volume) {
        this.outputNode.gain.value = volume;
    }
    output() { return this.outputNode; }
    getAutomationManager() { return this.automationManager; }
    stop(time) {
        if (time === undefined) {
            time = Tone.now();
        }
        const state = this._playingState.get(time);
        if (state && state.clip) {
            state.clip.stop(time);
        }
        this._playingState.add({ clip: null, time });
        return this;
    }
    _clipFired(clip, time) {
        this._firedState.add({ clip, time });
    }
    _clipStarted(clip, time) {
        this._playingState.add({ clip, time });
    }
    _clipPlaying(clip) {
        this._playingState = clip;
    }
    slot(n) {
        return this.clipSlots[n];
    }
    getDevice(name) {
        if (name === 'Mixer') {
            return this;
        }
        else {
            console.error(`Unknown device ${name}`);
        }
    }
    insert(object, position) {
        if (object instanceof Clip) {
            this.insertClip(object, position);
        }
        else if (object instanceof AudioEffect || object instanceof Tone.ToneAudioNode) {
            this.chain.insert(object, position);
        }
        else {
            throw Error('Incompatible object inserted into track');
        }
        return this;
    }
    insertClip(clip, position) {
        if (position === undefined) {
            throw Error('Track - insertClip: undefined position');
        }
        if (!this.clipSlots[position]) {
            this.clipSlots[position] = new ClipSlot(this);
        }
        this.clipSlots[position].insert(clip);
        clip.connect(this.chain.input());
    }
}
export default Track;
//# sourceMappingURL=Track.js.map